require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/utils/base.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/utils/base.legacy.js
// module id = 648
// module chunks = 31